// extracted by mini-css-extract-plugin
export default {"styles":"styles___mT8w4"};